<template>
    <div class="be-hero-button-group-container">
        <BeButton
            v-for="option in buttonOptions"
            :key="option.id"
            class="be-hero-button-group__button"
            :primary="selectedOption === option.id"
            @click="onOptionSelected(option.id)"
        >
            <i v-if="option.imageType === 'icon'" :class="option.image"></i>
            <img v-else-if="option.imageType === 'image'" :src="option.image" :alt="option.id" />
            <p>{{ option.id }}</p>
        </BeButton>
    </div>
</template>

<script>
import BeButton from "@/components/buttons/BeButton.vue";

export default {
    name: "BeHeroButtonGroup",

    components: {
        BeButton,
    },

    props: {
        buttonOptions: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            selectedOption: this.selected,
        }
    },

    watch: {
        selected(newVal) {
            this.selectedOption = newVal;
        },
    },

    // computed: {
    //     graphOptionsComputed() {
    //         return this.graphOptions;
    //     },
    // },

    methods: {
        onOptionSelected(id) {
            this.selectedOption = id;
            this.$emit('selected', id);
        }
    }
}
</script>

<style scoped lang="sass">
.be-hero-button-group-container
    display: flex
    gap: 10px

.be-hero-button-group__button ::v-deep .btn
    height: 90px !important
    width: 100px !important

    .be-button__button
        display: flex
        flex-direction: column
        font-size: large
        margin-top: 10px

        p
            margin: 20px 0 10px

</style>
